import {
    DELIVERY_LOADING,
    DELIVERY_SET,
    DELIVERY_ERROR,
    DELIVERY_ADD,
    DELIVERY_SHOW,
    DELIVERY_DELETE,
    DELIVERY_RESET,
    DELIVERY_EDIT,
    DELIVERY_CONFIRM,
    DELIVERY_UPDATE,
    DELIVERY_STOP_LOADING

} from './deliveryActions'

const initialState = {
    loading: false,
    data: [],
    error: null,
    success: null,
    idEdit: null,
    idShow: null,
}

const deliveryReducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case DELIVERY_STOP_LOADING:
            return {
                ...state,
                loading: false,
            }
        case DELIVERY_LOADING:
            return {
                ...state,
                loading: true,
            }
        case DELIVERY_SET:
            return {
                ...state,
                error: null,
                loading: false,
                data: payload
            }
        case DELIVERY_ADD:
            payload.is_active = payload.is_active === 1
            return {
                ...state,
                loading: false,
                error: null,
                data: [payload, ...state.data],
                success: 'New Delivery has been added successfully.'
            }
        case DELIVERY_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }
        case DELIVERY_SHOW:
            return {
                ...state,
                idShow: payload
            }
        case DELIVERY_DELETE:
            console.log('ini payload', payload)
            console.log('ini state', state)
            return {
                ...state,
                success: 'Data has been deleted successfully',
                data: state.data.filter(a => !payload.includes(a.id)),
                loading: false,
            }
        case DELIVERY_EDIT:
            return {
                ...state,
                error: null,
                success: null,
                idEdit: payload
            }
        case DELIVERY_RESET:
            return {
                ...state,
                error: null,
                success: null,
            }
        case DELIVERY_CONFIRM:
            console.log('111111111111', payload, type);

            let newData = state.data.map(d => {
                if (d.id === payload.id) {
                    d.status = payload.type;
                }
                return d
            })

            return {
                ...state,
                data: newData

            }
        case DELIVERY_UPDATE:
            return {
                ...state,
                loading: false,
                data: state.data.map(x => x.id === (state.idEdit || payload.id) ? payload : x),
                success: 'Data has been updated successfully.'
            }
            return {
                ...state,
                data: newData

            }
        default:
            return state;
    }
}

export default deliveryReducer
